import React, { useEffect, useState } from "react";
import EditableTable from "../../../../../../../components/Tables/EditableTable";
import { Box, Tab, Tabs } from "@mui/material";
import { useStructureModeling } from "../../structureModelingContext";
import { VideoModalBtn } from "../../../../../../../components/Modals/VideoModal";
import { tabsVideos } from "../links";

const columns = [
  { accessorKey: "Spec", header: "Spec", enableColumnActions: false },
  {
    accessorKey: "Components",
    header: "Components",
    enableColumnActions: false,
  },
  { accessorKey: "Size", header: "Size", enableColumnActions: false },

  {
    id: "Est. (Ref)",
    accessorFn: (row) => row["Est. (Ref)"],
    header: "Est. (Ref)",
    enableColumnActions: false,
  },

  { accessorKey: "Material", header: "Material", enableColumnActions: false },
  {
    accessorKey: "Requirements",
    header: "Requirements",
    enableColumnActions: false,
  },
  {
    accessorKey: "Rev",
    header: "Rev",
    muiEditTextFieldProps: { type: "number" },
    enableColumnActions: false,
  },
];

export function SpecTable() {
  const [tabIndex, setTabIndex] = useState(0);
  const { selectedSpecs, getSelectedSpecTable } = useStructureModeling();
  const currentSelect = selectedSpecs[tabIndex];

  const api = {
    getItems: () => getSelectedSpecTable(currentSelect),
  };

  return (
    <Box sx={{ bgcolor: "background.paper", border: "1px solid", borderColor: "divider", borderRadius: 1, overflow: "hidden" }}>
      <Tabs value={tabIndex} onChange={(e, newIndex) => setTabIndex(newIndex)} sx={{ borderBottom: "1px solid", borderColor: "divider" }}>
        {selectedSpecs.map((item) => (
          <Tab label={item.label} key={item.label} />
        ))}
        <VideoModalBtn
          src={tabsVideos.spec}
          sx={{ position: "absolute", right: 10, top: 5 }}
        />
      </Tabs>
      <EditableTable
        name="Spec"
        columns={columns}
        displayMode="modal"
        api={api}
        enableEditing={false}
        enableCreate={false}
        initialData={{}}
        parentId=""
      />
    </Box>
  );
}
